//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import { UsersTablePageModel } from '../Models/UsersTablePageModel';
import { UsersTablePageOptions } from '../Models/UsersTablePageOptions';
import { AdminMsAppLifecycleChartModel } from '../Models/AdminMsAppLifecycleChartModel';
import { AdminMsAppLifecycleChartOptions } from '../Models/AdminMsAppLifecycleChartOptions';
import { AdminUserSyncModel } from '../Models/AdminUserSyncModel';
import { AdminFakeApiFlagModel } from '../Models/AdminFakeApiFlagModel';
import { UserModel } from '../Models/UserModel';
import { AdminUserSubscriptionTypeModel } from '../Models/AdminUserSubscriptionTypeModel';
import { AdminUserLastPaymentDateModel } from '../Models/AdminUserLastPaymentDateModel';
import { AdminUserPaymentSourceModel } from '../Models/AdminUserPaymentSourceModel';
import { AdminUserSubscriptionEndDateModel } from '../Models/AdminUserSubscriptionEndDateModel';
import { AdminUserCommentModel } from '../Models/AdminUserCommentModel';
import { WbAccountModel } from '../Models/WbAccountModel';
import { UpdateWbAccountAllowOptionRequest } from '../Models/UpdateWbAccountAllowOptionRequest';
import { OzonAccountModel } from '../Models/OzonAccountModel';
import { UpdateOzonAccountAllowOptionRequest } from '../Models/UpdateOzonAccountAllowOptionRequest';
import { YandexMarketAccountModel } from '../Models/YandexMarketAccountModel';
import { UpdateYandexMarketAccountAllowOptionRequest } from '../Models/UpdateYandexMarketAccountAllowOptionRequest';
import { AdminRealizationReportAccountModel } from '../Models/AdminRealizationReportAccountModel';
import { AdminEnqueueRealizationReportRequest } from '../Models/AdminEnqueueRealizationReportRequest';

import { boundClass } from 'autobind-decorator';
import { AxiosInstance, AxiosResponse, AxiosRequestConfig } from 'axios';
import { encodeUrlParameter, getAxiosData } from '../../../common/urlUtility';
@boundClass export class AdminController
{
  constructor (axios: AxiosInstance)
  {
    this.axios = axios
  }
  
  private readonly axios: AxiosInstance
  
  addTestJob(name: string, duration?: number, queueName?: string, _config?: AxiosRequestConfig) : Promise<string>
  {
    return this.axios.get<string>(`Admin/AddTestJob?name=${encodeUrlParameter(name)}&duration=${encodeUrlParameter(duration)}&queueName=${encodeUrlParameter(queueName)}`, _config).then(getAxiosData)
  }
  

  addTestJobNoCancel(name: string, duration?: number, _config?: AxiosRequestConfig) : Promise<string>
  {
    return this.axios.get<string>(`Admin/AddTestJobNoCancel?name=${encodeUrlParameter(name)}&duration=${encodeUrlParameter(duration)}`, _config).then(getAxiosData)
  }
  

  addTestJobLong(name: string, durationMinutes?: number, _config?: AxiosRequestConfig) : Promise<string>
  {
    return this.axios.get<string>(`Admin/AddTestJobLong?name=${encodeUrlParameter(name)}&durationMinutes=${encodeUrlParameter(durationMinutes)}`, _config).then(getAxiosData)
  }
  

  addTestJobs(name: string, count: number, duration?: number, queueName?: string, _config?: AxiosRequestConfig) : Promise<string>
  {
    return this.axios.get<string>(`Admin/AddTestJobs?name=${encodeUrlParameter(name)}&count=${encodeUrlParameter(count)}&duration=${encodeUrlParameter(duration)}&queueName=${encodeUrlParameter(queueName)}`, _config).then(getAxiosData)
  }
  

  addTestJobsNoCancel(name: string, count: number, duration?: number, queueName?: string, _config?: AxiosRequestConfig) : Promise<string>
  {
    return this.axios.get<string>(`Admin/AddTestJobsNoCancel?name=${encodeUrlParameter(name)}&count=${encodeUrlParameter(count)}&duration=${encodeUrlParameter(duration)}&queueName=${encodeUrlParameter(queueName)}`, _config).then(getAxiosData)
  }
  

  testChainedJobs(count: number, jobDurationSeconds?: number, onlySucceess?: boolean, _config?: AxiosRequestConfig) : Promise<string>
  {
    return this.axios.get<string>(`Admin/TestChainedJobs/${encodeUrlParameter(count)}?jobDurationSeconds=${encodeUrlParameter(jobDurationSeconds)}&onlySucceess=${encodeUrlParameter(onlySucceess)}`, _config).then(getAxiosData)
  }
  

  impersonate(userId: string, _config?: AxiosRequestConfig) : Promise<AxiosResponse<unknown>>
  {
    return this.axios.get<unknown/*Microsoft.AspNetCore.Mvc.ActionResult*/>(`Admin/Impersonate/${encodeUrlParameter(userId)}`, _config)
  }
  

  deImpersonate(_config?: AxiosRequestConfig) : Promise<AxiosResponse<unknown>>
  {
    return this.axios.post<unknown/*Microsoft.AspNetCore.Mvc.ActionResult*/>(`Admin/DeImpersonate`, null, _config)
  }
  

  users(options: UsersTablePageOptions, _config?: AxiosRequestConfig) : Promise<UsersTablePageModel>
  {
    return this.axios.post<UsersTablePageModel>(`Admin/Users`, options, _config).then(getAxiosData)
  }
  

  msAppLifecycleChart(options: AdminMsAppLifecycleChartOptions, _config?: AxiosRequestConfig) : Promise<AdminMsAppLifecycleChartModel>
  {
    return this.axios.post<AdminMsAppLifecycleChartModel>(`Admin/MsAppLifecycleChart`, options, _config).then(getAxiosData)
  }
  

  setUserSync(model: AdminUserSyncModel, _config?: AxiosRequestConfig) : Promise<void>
  {
    return this.axios.post<void>(`Admin/SetUserSync`, model, _config).then(getAxiosData)
  }
  

  setFakeApiFlag(model: AdminFakeApiFlagModel, _config?: AxiosRequestConfig) : Promise<void>
  {
    return this.axios.post<void>(`Admin/SetFakeApiFlag`, model, _config).then(getAxiosData)
  }
  

  setUserSubscriptionType(model: AdminUserSubscriptionTypeModel, _config?: AxiosRequestConfig) : Promise<UserModel>
  {
    return this.axios.post<UserModel>(`Admin/SetUserSubscriptionType`, model, _config).then(getAxiosData)
  }
  

  setUserLastPaymentDate(model: AdminUserLastPaymentDateModel, _config?: AxiosRequestConfig) : Promise<void>
  {
    return this.axios.post<void>(`Admin/SetUserLastPaymentDate`, model, _config).then(getAxiosData)
  }
  

  setUserPaymentSource(model: AdminUserPaymentSourceModel, _config?: AxiosRequestConfig) : Promise<void>
  {
    return this.axios.post<void>(`Admin/SetUserPaymentSource`, model, _config).then(getAxiosData)
  }
  

  setUserSubscriptionEndDate(model: AdminUserSubscriptionEndDateModel, _config?: AxiosRequestConfig) : Promise<UserModel>
  {
    return this.axios.post<UserModel>(`Admin/SetUserSubscriptionEndDate`, model, _config).then(getAxiosData)
  }
  

  setUserAdminComment(model: AdminUserCommentModel, _config?: AxiosRequestConfig) : Promise<void>
  {
    return this.axios.post<void>(`Admin/SetUserAdminComment`, model, _config).then(getAxiosData)
  }
  

  getUserWbAccounts(userId: string, _config?: AxiosRequestConfig) : Promise<WbAccountModel[]>
  {
    return this.axios.get<WbAccountModel[]>(`Admin/GetUserWbAccounts/${encodeUrlParameter(userId)}`, _config).then(getAxiosData)
  }
  

  updateWbAccountsAllowOption(requests: UpdateWbAccountAllowOptionRequest[], _config?: AxiosRequestConfig) : Promise<void>
  {
    return this.axios.post<void>(`Admin/UpdateWbAccountsAllowOption`, requests, _config).then(getAxiosData)
  }
  

  getUserOzonFboAccounts(userId: string, _config?: AxiosRequestConfig) : Promise<OzonAccountModel[]>
  {
    return this.axios.get<OzonAccountModel[]>(`Admin/GetUserOzonFboAccounts/${encodeUrlParameter(userId)}`, _config).then(getAxiosData)
  }
  

  updateOzonAccountsAllowOption(requests: UpdateOzonAccountAllowOptionRequest[], _config?: AxiosRequestConfig) : Promise<void>
  {
    return this.axios.post<void>(`Admin/UpdateOzonAccountsAllowOption`, requests, _config).then(getAxiosData)
  }
  

  getUserYandexMarketFbyAccounts(userId: string, _config?: AxiosRequestConfig) : Promise<YandexMarketAccountModel[]>
  {
    return this.axios.get<YandexMarketAccountModel[]>(`Admin/GetUserYandexMarketFbyAccounts/${encodeUrlParameter(userId)}`, _config).then(getAxiosData)
  }
  

  updateYandexMarketAccountsAllowOption(requests: UpdateYandexMarketAccountAllowOptionRequest[], _config?: AxiosRequestConfig) : Promise<void>
  {
    return this.axios.post<void>(`Admin/UpdateYandexMarketAccountsAllowOption`, requests, _config).then(getAxiosData)
  }
  

  realizationReportAccounts(_config?: AxiosRequestConfig) : Promise<AdminRealizationReportAccountModel[]>
  {
    return this.axios.get<AdminRealizationReportAccountModel[]>(`Admin/RealizationReportAccounts`, _config).then(getAxiosData)
  }
  

  enqueueRealizationReport(request: AdminEnqueueRealizationReportRequest, _config?: AxiosRequestConfig) : Promise<void>
  {
    return this.axios.post<void>(`Admin/EnqueueRealizationReport`, request, _config).then(getAxiosData)
  }
  

  tariffs(_config?: AxiosRequestConfig) : Promise<string>
  {
    return this.axios.get<string>(`Admin/Tariffs`, _config).then(getAxiosData)
  }
  

  resetFakeApiCache(_config?: AxiosRequestConfig) : Promise<AxiosResponse<unknown>>
  {
    return this.axios.get<unknown/*Microsoft.AspNetCore.Mvc.ActionResult*/>(`Admin/ResetFakeApiCache`, _config)
  }
  

  stopUserLockHealthCheck(_config?: AxiosRequestConfig) : Promise<AxiosResponse<unknown>>
  {
    return this.axios.get<unknown/*Microsoft.AspNetCore.Mvc.ActionResult*/>(`Admin/StopUserLockHealthCheck`, _config)
  }
  

  recreateRedis(_config?: AxiosRequestConfig) : Promise<AxiosResponse<unknown>>
  {
    return this.axios.get<unknown/*Microsoft.AspNetCore.Mvc.ActionResult*/>(`Admin/RecreateRedis`, _config)
  }
  

  getLimitInfo(key: string, limit: number, _config?: AxiosRequestConfig) : Promise<string>
  {
    return this.axios.get<string>(`Admin/GetLimitInfo?key=${encodeUrlParameter(key)}&limit=${encodeUrlParameter(limit)}`, _config).then(getAxiosData)
  }
  

  resetLimit(key: string, _config?: AxiosRequestConfig) : Promise<string>
  {
    return this.axios.get<string>(`Admin/ResetLimit?key=${encodeUrlParameter(key)}`, _config).then(getAxiosData)
  }
  

  startThreadLogging(_config?: AxiosRequestConfig) : Promise<AxiosResponse<unknown>>
  {
    return this.axios.get<unknown/*Microsoft.AspNetCore.Mvc.ActionResult*/>(`Admin/StartThreadLogging`, _config)
  }
  

  stopThreadLogging(_config?: AxiosRequestConfig) : Promise<AxiosResponse<unknown>>
  {
    return this.axios.get<unknown/*Microsoft.AspNetCore.Mvc.ActionResult*/>(`Admin/StopThreadLogging`, _config)
  }
  

  getThreadPoolInfo(_config?: AxiosRequestConfig) : Promise<string>
  {
    return this.axios.get<string>(`Admin/GetThreadPoolInfo`, _config).then(getAxiosData)
  }
  

  getThreads(_config?: AxiosRequestConfig) : Promise<AxiosResponse<unknown>>
  {
    return this.axios.get<unknown/*Microsoft.AspNetCore.Mvc.ActionResult*/>(`Admin/GetThreads`, _config)
  }
  

  getThreadPool(_config?: AxiosRequestConfig) : Promise<AxiosResponse<unknown>>
  {
    return this.axios.get<unknown/*Microsoft.AspNetCore.Mvc.ActionResult*/>(`Admin/GetThreadPool`, _config)
  }
  

  setThreadPoolMin(worker: number, io: number, _config?: AxiosRequestConfig) : Promise<AxiosResponse<unknown>>
  {
    return this.axios.get<unknown/*Microsoft.AspNetCore.Mvc.ActionResult*/>(`Admin/SetThreadPoolMin?worker=${encodeUrlParameter(worker)}&io=${encodeUrlParameter(io)}`, _config)
  }
  

  setThreadPoolMax(worker: number, io: number, _config?: AxiosRequestConfig) : Promise<AxiosResponse<unknown>>
  {
    return this.axios.get<unknown/*Microsoft.AspNetCore.Mvc.ActionResult*/>(`Admin/SetThreadPoolMax?worker=${encodeUrlParameter(worker)}&io=${encodeUrlParameter(io)}`, _config)
  }
  

  pullMarketplaceCategories(queueName?: string, _config?: AxiosRequestConfig) : Promise<AxiosResponse<unknown>>
  {
    return this.axios.post<unknown/*Microsoft.AspNetCore.Mvc.ActionResult*/>(`Admin/PullMarketplaceCategories?queueName=${encodeUrlParameter(queueName)}`, null, _config)
  }
  

  /** Gets the full relative URL for the action */
  addTestJobUrl(name: string, duration?: number, queueName?: string, _config?: AxiosRequestConfig) : string
  {
    return `/api/Admin/AddTestJob?name=${encodeUrlParameter(name)}&duration=${encodeUrlParameter(duration)}&queueName=${encodeUrlParameter(queueName)}`
  }
  

  /** Gets the full relative URL for the action */
  addTestJobNoCancelUrl(name: string, duration?: number, _config?: AxiosRequestConfig) : string
  {
    return `/api/Admin/AddTestJobNoCancel?name=${encodeUrlParameter(name)}&duration=${encodeUrlParameter(duration)}`
  }
  

  /** Gets the full relative URL for the action */
  addTestJobLongUrl(name: string, durationMinutes?: number, _config?: AxiosRequestConfig) : string
  {
    return `/api/Admin/AddTestJobLong?name=${encodeUrlParameter(name)}&durationMinutes=${encodeUrlParameter(durationMinutes)}`
  }
  

  /** Gets the full relative URL for the action */
  addTestJobsUrl(name: string, count: number, duration?: number, queueName?: string, _config?: AxiosRequestConfig) : string
  {
    return `/api/Admin/AddTestJobs?name=${encodeUrlParameter(name)}&count=${encodeUrlParameter(count)}&duration=${encodeUrlParameter(duration)}&queueName=${encodeUrlParameter(queueName)}`
  }
  

  /** Gets the full relative URL for the action */
  addTestJobsNoCancelUrl(name: string, count: number, duration?: number, queueName?: string, _config?: AxiosRequestConfig) : string
  {
    return `/api/Admin/AddTestJobsNoCancel?name=${encodeUrlParameter(name)}&count=${encodeUrlParameter(count)}&duration=${encodeUrlParameter(duration)}&queueName=${encodeUrlParameter(queueName)}`
  }
  

  /** Gets the full relative URL for the action */
  testChainedJobsUrl(count: number, jobDurationSeconds?: number, onlySucceess?: boolean, _config?: AxiosRequestConfig) : string
  {
    return `/api/Admin/TestChainedJobs/${encodeUrlParameter(count)}?jobDurationSeconds=${encodeUrlParameter(jobDurationSeconds)}&onlySucceess=${encodeUrlParameter(onlySucceess)}`
  }
  

  /** Gets the full relative URL for the action */
  impersonateUrl(userId: string, _config?: AxiosRequestConfig) : string
  {
    return `/api/Admin/Impersonate/${encodeUrlParameter(userId)}`
  }
  

  /** Gets the full relative URL for the action */
  getUserWbAccountsUrl(userId: string, _config?: AxiosRequestConfig) : string
  {
    return `/api/Admin/GetUserWbAccounts/${encodeUrlParameter(userId)}`
  }
  

  /** Gets the full relative URL for the action */
  getUserOzonFboAccountsUrl(userId: string, _config?: AxiosRequestConfig) : string
  {
    return `/api/Admin/GetUserOzonFboAccounts/${encodeUrlParameter(userId)}`
  }
  

  /** Gets the full relative URL for the action */
  getUserYandexMarketFbyAccountsUrl(userId: string, _config?: AxiosRequestConfig) : string
  {
    return `/api/Admin/GetUserYandexMarketFbyAccounts/${encodeUrlParameter(userId)}`
  }
  

  /** Gets the full relative URL for the action */
  realizationReportAccountsUrl(_config?: AxiosRequestConfig) : string
  {
    return `/api/Admin/RealizationReportAccounts`
  }
  

  /** Gets the full relative URL for the action */
  tariffsUrl(_config?: AxiosRequestConfig) : string
  {
    return `/api/Admin/Tariffs`
  }
  

  /** Gets the full relative URL for the action */
  resetFakeApiCacheUrl(_config?: AxiosRequestConfig) : string
  {
    return `/api/Admin/ResetFakeApiCache`
  }
  

  /** Gets the full relative URL for the action */
  stopUserLockHealthCheckUrl(_config?: AxiosRequestConfig) : string
  {
    return `/api/Admin/StopUserLockHealthCheck`
  }
  

  /** Gets the full relative URL for the action */
  recreateRedisUrl(_config?: AxiosRequestConfig) : string
  {
    return `/api/Admin/RecreateRedis`
  }
  

  /** Gets the full relative URL for the action */
  getLimitInfoUrl(key: string, limit: number, _config?: AxiosRequestConfig) : string
  {
    return `/api/Admin/GetLimitInfo?key=${encodeUrlParameter(key)}&limit=${encodeUrlParameter(limit)}`
  }
  

  /** Gets the full relative URL for the action */
  resetLimitUrl(key: string, _config?: AxiosRequestConfig) : string
  {
    return `/api/Admin/ResetLimit?key=${encodeUrlParameter(key)}`
  }
  

  /** Gets the full relative URL for the action */
  startThreadLoggingUrl(_config?: AxiosRequestConfig) : string
  {
    return `/api/Admin/StartThreadLogging`
  }
  

  /** Gets the full relative URL for the action */
  stopThreadLoggingUrl(_config?: AxiosRequestConfig) : string
  {
    return `/api/Admin/StopThreadLogging`
  }
  

  /** Gets the full relative URL for the action */
  getThreadPoolInfoUrl(_config?: AxiosRequestConfig) : string
  {
    return `/api/Admin/GetThreadPoolInfo`
  }
  

  /** Gets the full relative URL for the action */
  getThreadsUrl(_config?: AxiosRequestConfig) : string
  {
    return `/api/Admin/GetThreads`
  }
  

  /** Gets the full relative URL for the action */
  getThreadPoolUrl(_config?: AxiosRequestConfig) : string
  {
    return `/api/Admin/GetThreadPool`
  }
  

  /** Gets the full relative URL for the action */
  setThreadPoolMinUrl(worker: number, io: number, _config?: AxiosRequestConfig) : string
  {
    return `/api/Admin/SetThreadPoolMin?worker=${encodeUrlParameter(worker)}&io=${encodeUrlParameter(io)}`
  }
  

  /** Gets the full relative URL for the action */
  setThreadPoolMaxUrl(worker: number, io: number, _config?: AxiosRequestConfig) : string
  {
    return `/api/Admin/SetThreadPoolMax?worker=${encodeUrlParameter(worker)}&io=${encodeUrlParameter(io)}`
  }
  

}
